import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const WelcomeToLuvly = lazyWithPreload(() => import('./WelcomeToLuvly'))
